import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';

import { withStyles } from '@material-ui/styles';
import React, { Component, Suspense } from 'react';

import { FullScreen } from 'react-full-screen';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { BrowserRouter, Route, Switch } from 'react-router-dom';

import { getClientList, getTokenData, getUserRoles } from './actions';

import './App.css';
import styles from './assets/jss/layoutStyle';
import themeObj from './assets/jss/theme';
import AutoLogout from './AutoLogout';
import HeaderView from './components/Header/HeaderView';
import AuthMethods from './components/Login/AuthMethods';
import NewChangePassword from './components/Login/NewChangePassword';
import NewForgetPassword from './components/Login/NewForgetPassword';
import NewLogin from './components/Login/NewLogin';
import NewOTPScreen from './components/Login/NewOTPScreen';
import OTPScreen from './components/Login/OTPScreen';
import SideNavigationView from './components/NavigationMenu/SideNavigationView';
import RequestADemoForm from './components/RequestADemo/RequestADemoForm';
import Toaster from './components/Utils/Toaster';
// import Footer from './components/Footer/Footer';
import { ROUTE } from './constant';
import i18n from './i18n';

import { EncryptionServices, MenuService } from './services';
import injectFullScreen from './services/injectFullScreen';

const AdminMainContentView = React.lazy(() => import('./components/Router/AdminContentView'));
const ClientMainContentView = React.lazy(() => import('./components/Router/ClientContentView'));

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      theme: themeObj[sessionStorage._theme] || themeObj.dark,
      selectLanguage: sessionStorage._lg || 'en-US',
      isExpired: false,
      type: '',
      // softwareSettingsData: '',
      isWhitelistIP: null,
    };
    const urlParams = new URLSearchParams(window.location.search);

    this.token = urlParams.get('token');
    this.appType = process.env.REACT_APP_AUDIENCE_TYPE;
  }

  UNSAFE_componentWillMount() {
    // if browser language is not Russian then default languahe is english
    if (sessionStorage._lg) {
      i18n.changeLanguage(sessionStorage._lg)
        .then(() => {
        });
    } else {
      i18n.changeLanguage(navigator.language === 'ru' ? navigator.language : 'en-US')
        .then(() => {
        });
    }

    const loginUser = sessionStorage.getItem('cred') ? JSON.parse(sessionStorage.getItem('cred')).userData : false;
    const { clientId } = loginUser;
    if (this.token) {
      const { getTokenData } = this.props;

      getTokenData(this.token).then((res) => {
        EncryptionServices.decodeJwtToken(this.token).then((decVal) => {
          this.setState({
            type: decVal.type,
          });
          if (new Date().getTime() > decVal.expires || (res && res.used)) {
            this.setState({
              isExpired: true,
            });
          }
        });
      });
    }
    if (clientId) {
      const { getClientList } = this.props;
      getClientList({ id: clientId });
    }
    const { getUserRoles: getUserRoles1 } = this.props;
    (loginUser) ? getUserRoles1(loginUser.role.roleName) : getUserRoles1();
  }

  checkForClientApp = () => (this.appType && (this.appType.toUpperCase()).trim() === 'CLIENTAPP');

  /**
   * function to change side menus style when click on switch menu
   */
  onChangeMenuType = () => {
    const { theme: newPaletteType } = this.state;
    newPaletteType.menu = newPaletteType.menu > 60 ? 60 : 250;
    this.setState({
      theme: newPaletteType,
    });
  };

  changeLanguage = (language) => {
    let lang;
    if (language === 'English') {
      lang = 'en-US';
    } else if (language === 'Russia') {
      lang = 'ru';
    }
    if (lang) {
      sessionStorage._lg = lang;
      this.setState({
        selectLanguage: lang,
      });
      i18n.changeLanguage(lang);
    }
  };

  /**
   *  function to check current theme and update accordingly
   */
  changeTheme = (themeType) => {
    let themeMode = themeType;
    /** ************** for header toggle start ************* */
    if (typeof themeType === 'object') {
      const { theme } = this.state;
      themeMode = theme.palette.type === 'light' ? 'dark' : 'light';
    }
    /** ************** for header toggle end *************** */
    sessionStorage._theme = themeMode;

    const newPaletteType = themeObj[themeMode];
    const { theme: theme1 } = this.state;
    newPaletteType.menu = theme1.menu;
    this.setState({
      theme: newPaletteType,
    });
  };

  /**
   * get user's permission for module
   */
  getUserRoles = () => {
    const loginUser = sessionStorage.getItem('cred') ? JSON.parse(sessionStorage.getItem('cred')).userData : false;

    const { getUserRoles: getUserRoles1 } = this.props;
    (loginUser) ? getUserRoles1(loginUser.role.roleName) : getUserRoles1();
  };

  // function to hide/show whitelist IP module
  handleWhitelistIPModule = (value) => {
    this.setState({
      isWhitelistIP: value,
    });
  };

  render() {
    // create multiple theme object
    const {
      theme,
      isExpired,
      type,
      selectLanguage,
      isWhitelistIP,
    } = this.state;
    const muiTheme = createMuiTheme(theme);

    const {
      classes,
      handle,
      userRoles,
      clientList,
    } = this.props;

    let roles = [];
    if (userRoles && userRoles.length) {
      roles = MenuService.getModulesName(userRoles);
    }
    const isLoggedIn = !!sessionStorage.getItem('authToken');
    const loginUser = sessionStorage.getItem('cred') ? JSON.parse(sessionStorage.getItem('cred')).userData : false;
    return (
      <FullScreen handle={handle}>
        <div className={classes.mainApp}>
          <AutoLogout />
          <MuiThemeProvider theme={muiTheme}>
            <BrowserRouter>
              <Switch>
                <Route
                  exact
                  path={ROUTE.LOGIN}
                  render={(props) => (
                    <NewLogin
                      {...props}
                      logo={theme.logo}
                      theme={theme}
                      changeTheme={this.changeTheme}
                      getPermission={this.getUserRoles}
                    />
                  )}
                />

                <Route
                  path={ROUTE.FORGET_PASSWD}
                  render={(props) => (
                    <NewForgetPassword
                      {...props}
                      logo={theme.logo}
                      theme={theme}
                      changeTheme={this.changeTheme}
                      getPermission={this.getUserRoles}
                    />
                  )}
                />

                <Route
                  path={ROUTE.REQUEST_DEMO}
                  render={(props) => (
                    <RequestADemoForm
                      {...props}
                      logo={theme.logo}
                      theme={theme}
                      changeTheme={this.changeTheme}
                      getPermission={this.getUserRoles}
                    />
                  )}
                />

                <Route
                  path={ROUTE.CHANGE_PASSWORD}
                  render={(props) => (
                    <NewChangePassword
                      {...props}
                      logo={theme.logo}
                      theme={theme}
                      changeTheme={this.changeTheme}
                      expired={isExpired}
                      type={type}
                    />
                  )}
                />
                <Route
                  path="/otp"
                  render={(props) => (
                    <NewOTPScreen
                      {...props}
                      logo={theme.logo}
                      theme={theme}
                      changeTheme={this.changeTheme}
                      getPermission={this.getUserRoles}
                    />
                  )}
                />
                <Route
                  path="/verify-recoveryCode"
                  render={(props) => (
                    <NewOTPScreen
                      logo={theme.logo}
                      theme={theme}
                      changeTheme={this.changeTheme}
                      {...props}
                      getPermission={this.getUserRoles}
                    />
                  )}
                />
                <Route
                  path="/login-methods"
                  render={(props) => (
                    <AuthMethods
                      {...props}
                      logo={theme.logo}
                      theme={theme}
                      changeTheme={this.changeTheme}
                      getPermission={this.getUserRoles}
                    />
                  )}
                />
                <Route
                  path="/verify-sms"
                  render={(props) => (
                    <NewOTPScreen
                      {...props}
                      logo={theme.logo}
                      theme={theme}
                      changeTheme={this.changeTheme}
                      getPermission={this.getUserRoles}
                    />
                  )}
                />
                <Route
                  path="/verify-securityKey"
                  render={(props) => (
                    <OTPScreen
                      {...props}
                      logo={theme.logo}
                      theme={theme}
                      changeTheme={this.changeTheme}
                      getPermission={this.getUserRoles}
                    />
                  )}
                />
                {isLoggedIn
                  ? (
                    <>
                      <HeaderView
                        logo={theme.logo}
                        handle={handle}
                        changeTheme={this.changeTheme}
                        currentLanguage={selectLanguage}
                        changeLanguage={this.changeLanguage}
                      />
                      <div className={theme.logo ? 'darkThemes' : 'lightThemes'}>
                        <SideNavigationView
                          loginUser={loginUser}
                          userRoles={roles}
                          isWhitelistIP={isWhitelistIP}
                          clientData={clientList}
                          onChangeMenuType={this.onChangeMenuType}
                        />
                        <MuiThemeProvider theme={muiTheme}>
                          <Suspense fallback={<div>Loading...</div>}>
                            {this.checkForClientApp()
                              ? (
                                <ClientMainContentView
                                  userRoles={roles}
                                  handleWhitelistIPModule={this.handleWhitelistIPModule}
                                  changeTheme={{
                                    method: this.changeTheme,
                                    value: theme,
                                  }}
                                  loginUser={loginUser}
                                />
                              )
                              : (
                                <AdminMainContentView
                                  userRoles={roles}
                                  changeTheme={{
                                    method: this.changeTheme,
                                    value: theme,
                                  }}
                                  loginUser={loginUser}
                                />
                              )}
                          </Suspense>
                        </MuiThemeProvider>
                      </div>
                    </>
                  )
                  : (
                    <Route
                      path={ROUTE.ALL}
                      render={
                        (props) => <NewLogin {...props} getPermission={this.getUserRoles} />
                      }
                    />
                  )}
              </Switch>
            </BrowserRouter>
          </MuiThemeProvider>
          <Toaster />
        </div>
      </FullScreen>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  getUserRoles: (role) => dispatch(getUserRoles(role)),
  getTokenData: (object) => dispatch(getTokenData(object)),
  getClientList: (object) => dispatch(getClientList(object)),
});

const mapStateToProps = (state) => ({
  userRoles: state.userRoles,
  usersList: state.usersList && state.usersList.data ? state.usersList.data : [],
  softwareList: state.softwareList && state.softwareList.data ? state.softwareList.data : [],
  clientList: state.clientList && state.clientList.data ? state.clientList.data : [],
  dashboardData: state.dashboardData && state.dashboardData.data ? state.dashboardData.data : [],
  platformData: state.platformData && state.platformData.data ? state.platformData.data : [],
  syslogSettingData: state.platformData && state.syslogSettingData.data ? state.syslogSettingData.data : [],
  systemEventList: state.systemEventList && state.systemEventList.data ? state.systemEventList.data : [],
  getMLScanList: state.getMLScanList && state.getMLScanList.data ? state.getMLScanList.data : [],
});

const stylesheets = withStyles(styles, { withTheme: true })(injectFullScreen(App));
export default withTranslation()(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(stylesheets),
);
